// Extend the Window interface to include fbq
declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}
/**
 * Initialize the Meta Pixel with the given ID
 */
export const initMetaPixel = (pixelId: string): void => {
  // Skip if fbq already exists (to prevent duplicate initialization)
  if (window.fbq) return
  // Create fbq function - following official Meta implementation
  window.fbq = function () {
    window.fbq.callMethod
      ? window.fbq.callMethod.apply(window.fbq, arguments)
      : window.fbq.queue.push(arguments)
  }
  // Initialize fbq if it doesn't exist
  if (!window._fbq) window._fbq = window.fbq
  window.fbq.push = window.fbq
  window.fbq.loaded = true
  window.fbq.version = '2.0'
  window.fbq.queue = []
  // Inject the Facebook Pixel script - following the exact pattern from Meta
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
  } else {
    document.head.appendChild(script)
  }
  // Initialize the pixel with the provided ID
  window.fbq('init', pixelId)
  // Track initial PageView
  window.fbq('track', 'PageView')
}
/**
 * Track a standard event
 */
export const track = (event: string, params?: Record<string, any>): void => {
  if (window.fbq) {
    if (params) {
      window.fbq('track', event, params)
    } else {
      window.fbq('track', event)
    }
  }
}
/**
 * Track a custom event
 */
export const trackCustom = (
  name: string,
  params?: Record<string, any>,
): void => {
  if (window.fbq) {
    if (params) {
      window.fbq('trackCustom', name, params)
    } else {
      window.fbq('trackCustom', name)
    }
  }
}
